import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function VehicleDetailsInput({
  label,
  currentValue,
  onSelect: onSelect,
  disabled = false,
  filterEnabled = true,
  onFilterEnabledChange,
}: {
  label: string;
  make?: string;
  model?: string;
  currentValue?: string;
  onSelect: (trim: string | null) => void;
  disabled?: boolean;
  filterEnabled?: boolean;
  onFilterEnabledChange?: (enabled: boolean) => void;
}) {
  const { t } = useTranslation("stock");
  const [value, setValue] = useState(currentValue ?? "");

  useEffect(() => {
    setValue(currentValue ?? "");
  }, [currentValue]);

  return (
    <div className="mt-1">
      <label className={`flex items-center gap-1.5 text-sm font-medium text-black ${onFilterEnabledChange ? "cursor-pointer" : ""}`}>
        {onFilterEnabledChange && (
          <input
            type="checkbox"
            checked={filterEnabled}
            onChange={(event) => onFilterEnabledChange(event.target.checked)}
            disabled={disabled}
            className="h-3.5 w-3.5 rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-50"
          />
        )}
        <span>{label}</span>
      </label>
      <input
        value={value}
        disabled={disabled || !filterEnabled}
        onChange={(e) => {
          setValue(e.target.value);
          onSelect(e.target.value || null);
        }}
        className="mt-1 w-full rounded-md border border-gray-400 px-3 py-2 text-sm disabled:bg-gray-100"
        placeholder={t("Any")}
      />
    </div>
  );
}
